import React from 'react';
import type { FactBoxBlockViewModel } from '../ViewModel/FactBoxBlockViewModel.csharp';
import { FactBox } from '~/Partials/FactBox/FactBox';

export const FactBoxBlock: React.FC<FactBoxBlockViewModel> = props => {
    const { content, heading, variant, translations } = props;

    return <FactBox heading={heading} variant={variant} content={content} translations={translations} />;
};
